<template>
  <div class="agreement-pager">
    <section class="scroll-list-wrap">
      <article ref="scroll"
                   :options="options">
        <div class="ql-container">
          <div class="ql-title">有讲课堂用户协议</div>
          <div class="ql-editor">
            <p>学技能，上有讲</p>
            <h1 class="ql-h1">有讲课堂产品和服务许可协议</h1>
             <p><span>《有讲课堂产品和服务许可协议》（以下简称“本协议”）是由您与广州酷思纬哲网络科技有限公司（以下简称“酷思纬哲”）就使用“有讲课堂”产品和服务所达成的协议。在您开始使用“有讲课堂”产品和服务之前，请您务必应认真阅读（未成年人应当在监护人陪同下阅读）并充分理解各条款内容，特别涉及是免除或者限制酷思纬哲责任的条款。</span>
            </p>
             <p><span>除非您完全接受本协议的全部内容，否则您无权使用“有讲课堂”产品和服务。若您使用“有讲课堂”产品，则视为您已充分理解本协议并同意签署本协议，承诺作为协议的一方当事人接受协议的约束。</span>
            </p>
            <h2 class="ql-h2">1. 协议范围</h2>
             <p><span>1.1 本协议约定了广州酷思纬哲网络科技有限公司和用户之间就使用“有讲课堂”产品和服务事宜发生的权利义务关系。</span>
            </p>
             <p><span>1.2 酷思纬哲：是指广州酷思纬哲网络科技有限公司，但就本协议涉及、及“有讲课堂”产品将来可能涉及的某些服务项目，酷思纬哲的关联企业也可能向您提供产品和服务，与您发生权利义务关系。</span>
            </p>
             <p><span>1.3 您：又称“用户”，是指任何以合法的方式获取和使用“有讲课堂”产品的人，不限于自然人或机构。</span>
            </p>
             <p><span>1.4 有讲课堂产品：又称“有讲课堂”或“有讲课堂软件”，是指由酷思纬哲合法拥有并运营的、标注名称为“有讲课堂”的移动客户端应用程序以及对应的域名为 “yojiang.cn” 的移动网站和PC网站。客户端应用程序以软件形式提供，包括但不限于iOS、Android等多个版本，用户必须选择与所安装终端设备相匹配的软件版本。</span>
            </p>
             <p><span>1.5 有讲课堂服务：指酷思纬哲向您提供的与“有讲课堂”产品相关的各项运营服务。</span>
            </p>
             <p><span>1.6 本协议内容同时包括酷思纬哲及其关联企业可能不断发布的关于“有讲课堂”产品和服务的业务规则、相关协议及其修订版本等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，用户同样应当遵守。</span>
            </p>
            <h2 class="ql-h2">2. 产品与服务</h2>
             <p><span>2.1 用户可以从合法的渠道下载“有讲课堂”产品到其合法拥有的终端设备中。但除非得到特别的授权，否则，用户不得以任何形式改编、复制或交易“有讲课堂”产品。如果你从未经酷思纬哲授权的渠道获取“有讲课堂”软件或与“有讲课堂”名称相同的安装程序，酷思纬哲无法保证该软件能够正常使用，并对因此给用户造成的损失不予负责。</span>
            </p>
             <p><span>2.2 一旦用户在其终端设备中打开“有讲课堂”产品，即视为使用“有讲课堂”产品和服务。为充分实现“有讲课堂”产品及服务的全部功能，用户可能需要将其终端设备联网。</span>
            </p>
             <p><span>2.3 酷思纬哲授权用户拥有中华人民共和国境内永久地、不可转让地、非独占地和非商业性地使用“有讲课堂”产品和服务的权利，但该权利不可转让，酷思纬哲也保留在任何必要情形下收回该授权的权利。</span>
            </p>
             <p><span>2.4 为了保证“有讲课堂”产品和服务的安全性和功能的一致性，酷思纬哲有权不经向用户特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</span>
            </p>
             <p><span>2.5 “有讲课堂”软件新版本发布后，旧版本的软件可能无法使用。酷思纬哲不保证旧版本软件继续可用，请用户随时核对并下载最新版本。</span>
            </p>
             <p><span>2.6 用户理解并同意：为了提供有效的服务，“有讲课堂”会利用用户终端设备的处理器和带宽等资源。“有讲课堂”使用过程中可能会产生数据流量费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</span>
            </p>
             <p><span>2.7 酷思纬哲有权根据实际情况自行决定单个用户在“有讲课堂”产品和服务中数据的最长储存期限，并在服务器上为其分配的存储空间。用户可根据自己的需要自行备份本软件及服务中的相关数据。</span>
            </p>
             <p><span>2.8 如果用户停止使用本软件及服务或服务被终止或取消，酷思纬哲可以从服务器上永久地删除用户的数据。服务停止、终止或取消后，酷思纬哲没有义务向用户返还任何数据。</span>
            </p>
            <h2 class="ql-h2">3. 账号和用户行为</h2>
             <p><span>3.1 “有讲课堂”为用户提供了注册通道，用户在有权选择合法并符合规定的字符组合作为自己的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是用户用以登录“有讲课堂”产品，并以注册用户身份使用产品或接受服务的凭证。“有讲课堂”账号的所有权归酷思纬哲所有，用户完成申请注册手续后，仅获得账号的使用权，且该使用权仅属于初始申请注册人。</span>
            </p>
             <p><span>3.2 您在“有讲课堂”中的注册账号仅限于您本人使用，禁止赠与、借用、出租或售卖。如果酷思纬哲发现或者有理由怀疑使用者并非账号初始注册人，则有权在未经通知的情况下，暂停或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。由此带来的包括并不限于用户通讯中断、用户资料和信息等清空等损失由用户自行承担。</span>
            </p>
             <p><span>3.3 用户有责任维护个人账号、密码的安全性与保密性，用户就以其注册账号名义所从事的一切活动负全部责任，包括用户数据的修改、发表的评论以及其他在“有讲课堂”产品上的操作行为。因此，用户应高度重视对账号与密码的保密。若发现他人未经许可使用其账号或发生其他任何安全漏洞问题时，用户应立即通知酷思纬哲。但无论因何种原因发生的密码泄露，均应由用户自行承担责任。</span>
            </p>
             <p><span>3.4 用户知晓账号及密码保管责任在于用户，酷思纬哲不承诺账号丢失或遗忘密码后用户能通过有效途径找回账号。</span>
            </p>
             <p><span>3.5 除自行注册“有讲课堂”账号外，用户也可选择通过“有讲课堂”的账号关联系统，授权使用其合法拥有的其他可关联的社交账号注册并登录“有讲课堂”产品。当用户以上述已有账号注册的，同样适用本协议中对账号的相关约定。</span>
            </p>
             <p><span>3.6 用户在使用“有讲课堂”产品和服务时，应当遵守中华人民共和国的法律。用户不得利用酷思纬哲的产品和服务从事上述法律法规、政策以及侵犯他人合法权利的行为。用户不得通过头像、用户名、昵称、网址、自述等个人资料冒充他人身份，无论是否发布信息。如果遇到上述情形，酷思纬哲保留收回账号的权利。</span>
            </p>
             <p><span>3.7 用户不得使用未经酷思纬哲授权或许可的任何插件、外挂或第三方工具对“有讲课堂”产品和服务的正常运行进行干扰、破坏、修改或施加其他影响。</span>
            </p>
             <p><span>3.8 用户不得利用或针对“有讲课堂”产品进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试“有讲课堂”产品系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏“有讲课堂”产品系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。</span>
            </p>
             <p><span>3.9 未经酷思纬哲许可，您不得在“有讲课堂”产品中进行任何诸如发布广告、销售商品的商业行为。</span>
            </p>
             <p><span>3.10 在任何情况下，如果酷思纬哲有理由认为用户的任何行为违反或可能违反上述约定的，酷思纬哲可在任何时候不经任何事先通知终止向用户提供服务。用户注册“有讲课堂”账号后如果长期不登录该账号，酷思纬哲有权回收该账号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。</span>
            </p>
             <p><span>3.11 酷思纬哲致力使评论成为文明、理性、友善、高质量的意见交流。在推动评论发展的同时，将不断加强相应的信息安全管理能力，完善跟帖评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。</span>
            </p>
             <p><span>3.12 如由于国家相关法律规定，用户需要在“有讲课堂”应用程序内输入真实身份信息时，用户应当以真实身份信息注册账号、使用评论服务。</span>
            </p>
             <p><span>3.13 用户不得在酷思纬哲的产品和服务内发表下列信息（包括但不限于通过发布评论、修改昵称等形式）：</span>
            </p>
             <p><span>（1）反对宪法确定的基本原则的；</span></p>
             <p><span
             >（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span></p>
             <p><span>（3）损害国家荣誉和利益的；</span></p>
             <p><span>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
            </p>
             <p><span>（5）煽动地域歧视、地域仇恨的；</span></p>
             <p><span>（6）破坏国家宗教政策，宣扬邪教和迷信的；</span>
            </p>
             <p><span>（7）散布谣言，扰乱社会秩序、破坏社会稳定的；</span>
            </p>
             <p><span
             >（8）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
            </p>
             <p><span>（9）侮辱或者诽谤他人，侵害他人合法权益的；</span>
            </p>
             <p><span
             >（10）对他人进行暴力恐吓、威胁，实施人肉搜索的；</span></p>
             <p><span>（11）未获得未满18周岁未成年人法定监护人的书面同意，传播该未成年人的隐私信息的；</span>
            </p>
             <p><span>（12）散布污言秽语，损害社会公序良俗的；</span>
            </p>
             <p><span>（13）侵犯他人知识产权的；</span></p>
             <p><span>（14）散布商业广告，或类似的商业招揽信息；</span>
            </p>
             <p><span
             >（15）使用本网站常用语言文字以外的其他语言文字评论的；</span>
            </p>
             <p><span>（16）与所评论的信息毫无关系的；</span></p>
             <p><span
             >（17）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</span></p>
             <p><span>（18）法律、法规和规章禁止传播的其他信息。</span>
            </p>
             <p><span>3.14 对违反上述条款的用户，酷思纬哲将视情况采取拒绝发布、删除评论、短期禁止发言直至永久关闭账号等管理措施，涉嫌违法犯罪的评论将被保存在案、并在接受有关政府部门调查时如实报告。</span>
            </p>
             <p><span>3.15 用户在“有讲课堂”发表的内容仅表明其个人的立场和观点，并不代表酷思纬哲的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。酷思纬哲不承担任何法律及连带责任。</span>
            </p>
             <p><span>3.16 酷思纬哲将完善公众举报平台，欢迎用户监督举报各类不法传播活动和违法有害信息，以共同营造清朗的网络空间。</span>
            </p>
             <p><span>3.17 酷思纬哲非常重视对未成年人个人信息的保护。若用户是18周岁以下的未成年人，在使用酷思纬哲的服务前，应事先取得家长或法定监护人的书面同意。</span>
            </p>
             <p><span>3.18 用户充分了解并同意，用户必须为自己注册账号下的一切行为负责，包括所发表的任何内容以及由此产生的任何后果。用户应对“有讲课堂”产品和服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。酷思纬哲无法且不会对因前述风险而导致的任何损失或损害承担责任。</span>
            </p>
            <h2 class="ql-h2">4. 知识产权</h2>
             <p><span>4.1 未经相关权利人同意，用户不得对“有讲课堂”产品和服务涉及的相关网页、应用、软件等产品进行反向工程、反向汇编、反向编译等。</span>
            </p>
             <p><span>4.2 用户在使用“有讲课堂”产品和服务时发表上传的文字、图片、视频、软件以及表演等用户原创的信息，此知识产权归属用户，但用户的发表、上传行为表明该信息对酷思纬哲非独占性、永久性和可转让的授权。酷思纬哲可将上述信息在“有讲课堂”中使用，可在酷思纬哲的其他产品中使用，也可以由酷思纬哲授权给合作方使用。</span>
            </p>
             <p><span>4.3 用户应保证，在使用“有讲课堂”产品和服务时上传的文字、图片、视频、软件以及表演等信息不侵犯任何第三方知识产权。否则，酷思纬哲有权移除该侵权信息，并对此不负任何责任。如前述第三方提出权利主张，用户应自行承担责任，并保证酷思纬哲不会因此而遭受任何损失。</span>
            </p>
             <p><span>4.4 “有讲课堂”产品和服务中的“主题”和“消息”来自于对互联网各种信息源的摘录、编辑和汇总，与“消息”相对应的原文均通过程序内置浏览器链接至外部原文网址，用户可自行点击查看。在这一过程中，酷思纬哲无权亦不会更改外部网页的内容和版式。用户应对外部链接中内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。酷思纬哲无法且不会对因前述风险而导致的任何损失或损害承担责任。</span>
            </p>
             <p><span>4.5 为介绍、评论某一作品或者说明某一问题，酷思纬哲在“有讲课堂”产品和服务中适当引用已经发表的作品，无需经原著作权人许可。“有讲课堂”产品和服务中可能涉及到第三方知识产权，而该第三方对于您在“有讲课堂”产品和服务中使用该知识产权有要求时，酷思纬哲将以适当形式告知您该要求，您应当一并遵守。</span>
            </p>
             <p><span>4.6 酷思纬哲是“有讲课堂”产品和服务的知识产权权利人。“有讲课堂”享有的或可能享有的一切商标权、著作权、专利权和商业秘密等知识产权，以及由酷思纬哲构思创作并提供的与“有讲课堂”产品和服务相关的信息内容（包括但不限于网页、文字、图片、作品汇编、改编、版面设计、有关数据等）的知识产权，均归属于酷思纬哲所有。</span>
            </p>
             <p><span>4.7 “有讲课堂”产品和服务中所包含的内容的知识产权均受到法律保护，未经酷思纬哲、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</span>
            </p>
            <h2 class="ql-h2">5. 个人信息和隐私</h2>
             <p><span>5.1 用户在注册账号或使用“有讲课堂”产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实的身份信息。若用户填写的信息不完整，则无法使用相关产品或服务或在使用过程中受到限制。</span>
            </p>
             <p><span>5.2 酷思纬哲将运用各种安全技术和程序建立完善的管理制度来保护用户的个人信息，以免遭受未经授权的访问、使用或披露。但用户同时理解，由于互联网的开放性以及技术更新非常快，非酷思纬哲可控制的因素导致用户信息泄漏的，酷思纬哲不承担责任。</span>
            </p>
             <p><span
             >5.3 酷思纬哲不会将您的个人信息转移或披露给任何非关联的第三方，除非：</span></p>
             <p><span>（1）相关法律法规或法院、政府机关要求；或</span>
            </p>
             <p><span>（2）为完成合并、分立、收购或资产转让而转移；或</span>
            </p>
             <p><span>（3）为提供您要求的服务所必需。</span></p>
             <p><span>5.4 请用户注意勿在使用“有讲课堂”产品和服务时随意透露您或他人的各类财产帐户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此带来的任何损失由用户自行承担。用户不应将自认为隐私的信息通过“有讲课堂”产品发表、上传或扩散。酷思纬哲不对因此造成的损失承担任何责任。</span>
            </p>
             <p><span
             >5.5 在以下情况下，酷思纬哲有权使用用户的个人信息：</span>
            </p>
             <p><span>（1）在进行促销或抽奖时，酷思纬哲可能会与赞助商或合作伙伴共享用户的个人信息，在这些情况下酷思纬哲会在发送用户信息之前进行提示，并且用户可以通过不参与促销或抽奖活动来终止传送过程；</span>
            </p>
             <p><span>（2）酷思纬哲可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与酷思纬哲同等的保护用户隐私的责任，则酷思纬哲有权将用户的注册资料等提供给该第三方；</span>
            </p>
             <p><span>（3）在不透露单个用户隐私资料的前提下，酷思纬哲有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</span>
            </p>
            <h2 class="ql-h2">6. 服务的变更、中断和终止</h2>
             <p><span>6.1 用户理解并同意，酷思纬哲提供的“有讲课堂”产品和服务是按照现有技术和条件所能达到的现状提供的。酷思纬哲会尽最大努力向您提供服务，确保服务的连贯性和安全性；但酷思纬哲不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、网络环境、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。对于上述原因造成的用户数据损失，酷思纬哲无须向用户或第三方负责或承担任何赔偿责任。</span>
            </p>
             <p><span>6.2 用户理解并同意，酷思纬哲为了服务整体运营的需要，有权在不事先通知用户的情况下修改、中断、中止或终止“有讲课堂”产品内的各项服务，而无须向用户或第三方负责或承担任何赔偿责任。</span>
            </p>
             <p><span>6.3  “有讲课堂”产品中包含酷思纬哲以各种合法方式获取的外部网络内容或服务链接，您可以通过在“有讲课堂”中提供的链接跳转到外部网页获取相关内容和服务。外部网页所涉及的服务可能需要您同时接受该服务特别制订的用户协议、使用协议或者其他约束您与该项服务提供者之间的法律文件。一旦您开始使用上述外部服务，则视为您同时接受有关单项服务的相关法律文件的约束。同时，关于您在这些外部服务中所产生的权利和义务，除非另有约定，酷思纬哲无需向您或第三方的服务内容与效果承担任何责任。</span>
            </p>
            <h2 class="ql-h2">7. 法律责任声明</h2>
             <p><span>7.1 酷思纬哲对于任何自“有讲课堂”产品和服务中获得的他人的信息、内容或者广告宣传等任何资讯（以下统称“讯息”），不负保证真实、准确和完整性的责任。如果任何单位或者个人通过上述“讯息”而进行任何行为，须自行甄别真伪和谨慎预防风险，否则，无论何种原因，酷思纬哲不对任何非与本应用程序直接发生的交易和（或）行为承担任何直接、间接、附带或衍生的损失和责任。</span>
            </p>
             <p><span>7.2 酷思纬哲不保证产品和服务完全适合用户的使用要求；不保证产品或服务不受干扰，及时、安全、可靠，或不出现错误用户；不保证经由酷思纬哲取得的任何产品、服务或其他材料符合用户的期望；不保证产品或服务中任何错误都将能得到更正。</span>
            </p>
             <p><span>7.3 基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，酷思纬哲不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任（即使酷思纬哲事先已被告知发生此种赔偿之可能性亦然）：</span>
            </p>
             <p><span>（1）对酷思纬哲的产品的使用或无法使用；</span></p>
             <p><span>（2）酷思纬哲的产品不受干扰，及时、安全、可靠或不出现错误；用户经由酷思纬哲取得的任何产品、服务或其他材料符合用户的期望；</span>
            </p>
             <p><span>（3）软件中的任何错误或不稳定；</span></p>
             <p><span>（4）任何第三方在本软件服务中所作的声明或行为；</span>
            </p>
             <p><span
             >（5）用户基于在产品或服务中发布的广告信息，向第三方购买商品或服务；</span></p>
             <p><span
             >（6）其他与酷思纬哲相关的事宜，但本用户协议有明确规定的除外。</span></p>
             <p><span>7.4 对违反有关法律法规或本协议规定的行为，酷思纬哲将依法律规定及上述规则等加以合理判断进行处理，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息并向有关部门报告等。</span>
            </p>
            <h2 class="ql-h2">8. 违约责任</h2>
             <p><span>8.1 用户因违反国家法律法规或本协议的约定，或用户侵害他人任何权利因而衍生或导致任何第三人向酷思纬哲提出任何索赔或请求，包括但不限于诉讼费用、律师费用、差旅费用、和解金额、罚款或生效法律文书中规定的损害赔偿金额、软件使用费等而给酷思纬哲造成损失的，用户应赔偿酷思纬哲因此而遭受的一切损失，并消除影响。</span>
            </p>
             <p><span>8.2 如果酷思纬哲发现或收到他人举报或投诉用户违反本协议约定的，酷思纬哲有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并有权公告处理结果。</span>
            </p>
            <h2 class="ql-h2">9. 其他条款</h2>
             <p><span
             >9.1 您使用“有讲课堂”产品和服务即视为您已阅读并同意受本协议的约束。</span></p>
             <p><span>9.2 本协议可能因国家政策、产品以及履行环境发生变化而进行修改，酷思纬哲有权在必要时变更本协议条款，并在相关网站、页面或应用程序内进行通知。您也可以在酷思纬哲及“有讲课堂”产品的相关页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用“有讲课堂”产品和服务，即视为您已接受变更后的协议。如果您不接受变更后的协议，应当停止登录或使用“有讲课堂”产品和服务。</span>
            </p>
             <p><span>9.3 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。倘本协议之任何规定因与中国法律抵触而无效，则这些条款将尽可能接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。本协议的签署地点为酷思纬哲公司所在地（广州市天河区），若用户与酷思纬哲发生争议的，双方同意将争议提交广州市天河区法院诉讼解决。</span>
            </p>
             <p><span>9.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</span>
            </p>
             <p><span>9.5 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</span>
            </p>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import wxShare from '@/common/js/wxShare';

export default {
  name: 'agreement',
  computed: {
    options() {
      return {
        scrollbar: true,
        useTransition: false,
      };
    },
  },
  mounted() {
    wxShare();
  },
};
</script>

<style scoped lang="stylus">
  @import "./../../common/stylus/variable.styl"
  @import "./../../common/stylus/mixin.styl"

  .agreement-pager {
    position: relative
    z-index: 102
    margin: auto
    width: 100vw
    min-height: 100vh
    max-width: 640px
    background-color: #fff
    overflow: hidden
  }

  .ql-container {
    padding: 15px 20px
    width: 100%
    font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Helvetica,Tahoma,Arial,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",sans-serif
    .ql-title {
      box-sizing: content-box;
      margin: 0;
      width: auto;
      font-size: 22.5pt;
      font-weight: 800
      height: 60px;
      padding-top: 30px;
      border-bottom: 1px solid $color-line-l;
    }
    .ql-editor {
      padding: 20px 0 100px
      text-align: justify
      p {
        line-height: 2
        color: $color-text
      }
    }
    .ql-h1 {
      padding: 40px 0 15px;
      font-size: 22px;
      font-weight: 900
      line-height: 36px
      color: $color-text
    }
    .ql-h2 {
      padding: 30px 0 15px;
      font-size: 22px;
      font-weight: 900
      line-height: 36px
      color: $color-text
    }
  }

  // 暗黑模式
  @media (prefers-color-scheme: dark) {
    .agreement-pager {
      background-color: $darkmode-color-bg;
    }
    .ql-container {
      .ql-title {
        border-bottom-color $darkmode-color-line-l
        color: $darkmode-color-text
      }
      .ql-editor {
        p {
          color: $darkmode-color-text
        }
      }
      .ql-h1 {
        color: $darkmode-color-text
      }
      .ql-h2 {
        color: $darkmode-color-text
      }
    }
  }

</style>
